import React, { Fragment, useState, useEffect, useContext } from 'react';
import { LoginContext } from '../../hooks/context/LoginContext';
import FormInput from './FormInput';

import { getApiUrl, axiosPost, MiReplaceAll, getAhoraddmmyyyy, getAhorayyyymmdd, getPantDocFromNivel, setStockOptionsSelectUbiLarge, getStockOptionsSelectUbi, getTitle, encryptData, getDecodedCookie } from '../../helpers/helperApp';

function MiInputDataTableLargeInv(props){    

    const { apiKey, appCryptCom  } = useContext(LoginContext);   

    const { valueProp, saveValueProp, functionAfterChange, saveValueIsArray, readOnly, disabled } = props;    
        
    const [ input, saveInput ] = useState("");

    const handleInput = (e) => {        
        const { name, value } = e.target;
        if(value != valueProp){
            saveInput(value)         
            if (saveValueIsArray) {
                saveValueProp(prevState => {
                    const updatedArray = Array.isArray(prevState) ? [...prevState] : [];
                    const existingIndex = updatedArray.findIndex(item => item.id === saveValueIsArray.id);
                        
                    if (existingIndex !== -1) {
                        updatedArray[existingIndex][saveValueIsArray.valuekey] = value;                    
                    }                                                                            
                    return updatedArray;
                });
            } else {
                saveValueProp(value);            
            } 
            
            if(functionAfterChange) functionAfterChange();
        }
    }

    return(
        <Fragment>                   
            <input  
                type={ "number" } 
                className={ "form-control text-right"} 
                id={ saveValueIsArray.id } 
                // name={ "" } 
                // placeholder={ "" }
                // value={ valueProp }
                defaultValue={ valueProp }  
                // onChange={ e => handleChangeNum1(e) } 
                onBlur={ e => handleInput(e) } 
                // required={ null } 
                disabled={ disabled == true || disabled == "disabled" ? true : false  } 
                readOnly={ readOnly == true || readOnly == "readonly" ? true : false  } 
                min={0}                                                                        
            />  
        </Fragment>        
    )

}

export default MiInputDataTableLargeInv;